import { Box } from "@mui/material";

import CustomText from "./CustomText";

const getDoctorName = (doctor) =>
  [doctor?.nombre, doctor?.apellido_paterno, doctor?.apellido_materno]
    .filter(Boolean)
    .join(" ");

const DoctorCard = ({ doctor, colorIcon, onClick }) => {
  const doctorName = getDoctorName(doctor) || "Médico";
  const specialty = doctor?.especialidad || "Especialista";

  return (
    <Box sx={styles.CardWrapper} onClick={onClick}>
      <Box sx={styles.CardInner}>
        <Box sx={styles.CardFront}>
          <Box sx={styles.ImageContainer}>
            <Box
              component="img"
              src={doctor?.imagen}
              alt={doctorName}
              sx={styles.DoctorImage}
            />
          </Box>

          <Box sx={styles.Information}>
            <Box sx={styles.DoctorInfo}>
              <CustomText
                fontFamily="Nunito"
                fontWeight={700}
                fontSize={{ xs: 16, md: 16 }}
                color="#2349D0"
              >
                Dr. {doctorName}
              </CustomText>
              <CustomText
                fontFamily="Nunito"
                fontSize={{ xs: 11, md: 13 }}
                color="#777"
              >
                {specialty}
              </CustomText>
            </Box>
          </Box>
        </Box>

        <Box sx={styles.CardBack}>
          <CustomText
            fontFamily="Nunito"
            fontWeight={700}
            fontSize={{ xs: 20, md: 18 }}
            color="#2349D0"
          >
            Dr. {doctorName}
          </CustomText>
          <CustomText
            fontFamily="Nunito"
            fontSize={{ xs: 14, md: 14 }}
            color="#666"
            marginBottom={2}
          >
            {specialty}
          </CustomText>

          {doctor?.centro_estudios && (
            <Box sx={styles.BackInfo}>
              <CustomText
                fontFamily="Nunito"
                fontWeight={600}
                fontSize={{ xs: 10, md: 12 }}
                color="#999"
              >
                Centro de estudios
              </CustomText>
              <CustomText
                fontFamily="Nunito"
                fontSize={{ xs: 11, md: 13 }}
                color="#333"
                lineHeight={1.2}
              >
                {doctor.centro_estudios}
              </CustomText>
            </Box>
          )}

          {doctor?.cedula && (
            <Box sx={styles.BackInfo}>
              <CustomText
                fontFamily="Nunito"
                fontWeight={600}
                fontSize={{ xs: 10, md: 12 }}
                color="#999"
              >
                Cédula profesional
              </CustomText>
              <CustomText
                fontFamily="Nunito"
                fontSize={{ xs: 11, md: 13 }}
                color="#333"
                lineHeight={1.2}
              >
                {doctor.cedula}
              </CustomText>
            </Box>
          )}

          <Box
            component="button"
            onClick={(event) => {
              event.stopPropagation();
              onClick?.();
            }}
            sx={styles.BackButton}
          >
            Más información
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DoctorCard;

const styles = {
  CardWrapper: {
    width: {
      xs: "calc(100vw - 100px)",
      sm: 280,
      md: 205,
      lg: 280,
    },
    minWidth: {
      xs: "calc(100vw - 100px)",
      sm: 280,
      md: 205,
      lg: 205,
    },
    height: {
      xs: 310,
      sm: 320,
      md: 245,
      lg: 320,
    },
    perspective: "1000px",
    cursor: "pointer",
  },
  CardInner: {
    position: "relative",
    width: "100%",
    height: "100%",
    transformStyle: "preserve-3d",
    transition: "transform 0.7s ease",
    "&:hover": {
      transform: "rotateY(180deg)",
    },
  },
  CardFront: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.20)",
    display: "flex",
    flexDirection: "column",
    backfaceVisibility: "hidden",
  },
  CardBack: {
    position: "absolute",
    inset: 0,
    backgroundColor: "#F1F1F1",
    borderRadius: "20px",
    padding: {
      xs: 2,
      md: 2,
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.20)",
    transform: "rotateY(180deg)",
    backfaceVisibility: "hidden",
  },
  ImageContainer: {
    width: "100%",
    height: {
      xs: 245,
      sm: 250,
      md: 205,
      lg: 240,
    },
    borderRadius: "20px",
    overflow: "hidden",
    // borderRadius: "20px 20px 0 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  DoctorImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    display: "block",
  },
  Information: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  DoctorInfo: {
    minWidth: 0,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  BackInfo: {
    width: "100%",
    marginBottom: 1.5,
  },
  BackButton: {
    border: "none",
    color: "#FFFFFF",
    backgroundColor: "#782A9F",
    borderRadius: "20px",
    padding: "10px 19px",
    fontFamily: "Nunito",
    fontSize: {
      xs: 10,
      md: 13,
    },
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 1,
    "&:hover": {
      opacity: 0.85,
    },
  },
};
